import React, {FC, useState, useEffect} from "react"

import theme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import {H4, Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Button, {IconTypes} from "@irati/ui/src/Button"
import {OnboardingReportStep} from "@irati/types"
import Icon from "@irati/ui/src/Icon"

import RadialSteps from "../../RadialSteps"
import {Container} from "./styled"
import OnboardingStep from "./OnboardingStep"
import {HEADLINES, ONBOARDING_STEPS, Step} from "./OnboardingSteps"


interface Props {
  reportingSteps?: OnboardingReportStep[]
}

const OnboardingProgress: FC<Props> = ({reportingSteps}) => {
  const [expanded, setExpanded] = useState<boolean>(false)
  const [completed, setCompleted] = useState<number>(0)
  const [steps, setSteps] = useState<Step[]>(ONBOARDING_STEPS)

  const [title, setTitle] = useState<string>(HEADLINES[0].title)
  const [subTitle, setSubtitle] = useState<string>(HEADLINES[0].subTitle)
  const [button, setButton] = useState<string>(HEADLINES[0].button)

  const mapOnboardingSteps = () => {
    const updatedSteps = ONBOARDING_STEPS
    updatedSteps.map((step) => {
      step.actions.map((item) => {
        const completedAction = reportingSteps?.find((s) => s.step === item.name)?.complete
        item.complete = completedAction || false
      })
    })
    setSteps(updatedSteps)
  }

  const getCompletedSteps = () => {
    let completedSteps = completed
    steps.map((step) => {
      if (step.actions.filter((a) => a.complete === false).length === 0) {
        completedSteps +=1
      }
    })
    setCompleted(completedSteps)
    handleHeadlines(completedSteps)
  }

  const handleHeadlines = (value: number) => {
    switch(value) {
      case 0:
        return setHeadlines(0)
      case 4:
        return setHeadlines(2)
      default:
        return setHeadlines(1)
    }
  }

  const setHeadlines = (index: number) => {
    setTitle(HEADLINES[index].title)
    setSubtitle(HEADLINES[index].subTitle)
    setButton(HEADLINES[index].button)
  }

  useEffect(() => {
    mapOnboardingSteps()
    getCompletedSteps()
  }, [reportingSteps])

  return (
    !expanded
      ? <Container marginBottom={8} justifyContent="space-between" padding={[3]} id="adminSection_OnboardingSteps_collapsed">
        <Flex>
          <RadialSteps completed={completed} steps={steps.length} fill={theme.colors.greys.lightest} />
          <Flex direction="column" alignSelf="center" marginLeft={2}>
            <H4 marginBottom color={theme.colors.filterChip}>
              <FormattedMessage id={title} />
            </H4>
            <Body>
              <FormattedMessage id={subTitle} />
            </Body>
          </Flex>
        </Flex>
        <Flex alignSelf="center" marginLeft>
          <Button id="adminSection_onboardingGetStarted_button" primary onClick={() => setExpanded(true)}>
            <FormattedMessage id={button} />
          </Button>
        </Flex>
      </Container>
      : <>
        <Flex justifyContent="space-between" marginBottom={3}>
          <Flex>
            <RadialSteps completed={completed} steps={4} fill={theme.colors.utility.white} />
            <Flex direction="column" alignSelf="center" marginLeft={2}>
              <H4 marginBottom color={theme.colors.filterChip}>
                <FormattedMessage id={title} />
              </H4>
              <Body>
                <FormattedMessage id={subTitle} />
              </Body>
            </Flex>
          </Flex>
          <Flex alignSelf="center" marginLeft>
            <Button id="adminSection_closeOnboardingSteps_button" marginRight tertiary onClick={() => setExpanded(false)}>
              <Icon icon={IconTypes.arrowUp} size={16} />
            </Button>
          </Flex>
        </Flex>
        <Flex width="100%" wrap="wrap" gap={theme.spacing.one} marginBottom={8} id="adminSection_OnboardingSteps_expanded">
          {steps?.map((step) => (
            <OnboardingStep step={step} />
          ))}
        </Flex>
      </>
  )
}

export default OnboardingProgress
